<template>
  <div class="mapboxgl-custom-control">
    <!-- zoom controls -->
    <v-card class="control-zoom mb-2">
      <v-btn flat icon :ripple="false" class="ma-0" @click="zoomIn">
        <fa-icon
          :icon="['far', 'plus']"
          fixed-width />
      </v-btn>

      <v-divider />

      <v-btn flat icon :ripple="false" class="ma-0" @click="zoomOut">
        <fa-icon
          :icon="['far', 'minus']"
          fixed-width />
      </v-btn>
    </v-card>

    <!-- filter button control -->
    <div class="control-filter-container">
      <v-card v-show="showToggleGroup" class="control-toggle">
        <div class="px-3 py-2">
          <v-switch hide-details v-model="railroads" label="Railroads" color="#ff2424" height="18" class="caption mt-0 mb-2" />
          <v-switch hide-details v-model="oilpipelines" label="Oil Lines" color="#58618d" height="18" class="mt-0 mb-2" />
          <v-switch hide-details v-model="gaspipelines" label="Gas Lines" color="#949db8" height="18" class="mt-0 mb-2" />
          <v-switch hide-details v-model="ports" label="Ports" color="#479a89" height="18" class="mt-0 mb-1" />
        </div>
      </v-card>

      <v-card class="control-filter">
        <v-btn flat icon :ripple="false" class="ma-0" @click="showToggleGroup = !showToggleGroup">
          <fa-icon
            :icon="['far', 'filter']"
            fixed-width />
        </v-btn>
      </v-card>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ControlFinal',
  data() {
    return {
      showToggleGroup: true,
    };
  },
  computed: {
    railroads: {
      get() {
        return this.$store.getters['viewFinal/railroads'];
      },
      set() {
        this.$store.dispatch('viewFinal/updateVisibility', 'railroads');
      },
    },
    oilpipelines: {
      get() {
        return this.$store.getters['viewFinal/oilpipelines'];
      },
      set() {
        this.$store.dispatch('viewFinal/updateVisibility', 'oilpipelines');
      },
    },
    gaspipelines: {
      get() {
        return this.$store.getters['viewFinal/gaspipelines'];
      },
      set() {
        this.$store.dispatch('viewFinal/updateVisibility', 'gaspipelines');
      },
    },
    ports: {
      get() {
        return this.$store.getters['viewFinal/ports'];
      },
      set() {
        this.$store.dispatch('viewFinal/updateVisibility', 'ports');
      },
    },
  },
  methods: {
    zoomIn() {
      this.$store.dispatch('viewFinal/zoomIn');
    },
    zoomOut() {
      this.$store.dispatch('viewFinal/zoomOut');
    },
  },
};
</script>

<style lang="stylus" scoped>
.control-zoom, .control-filter {
  .v-btn:before {
    border-radius: unset;
  }
}

.control-filter-container {
  position: relative;

  .control-toggle {
    width: 11vw;
    position: absolute;
    right: 46px;

    >>> .v-input__slot {
      margin-bottom: 0 !important;
    }

    >>> .v-label {
      font-size: 13px;
    }
  }
}
</style>
